import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { EventModel, EventOptionGroup, FootballStats } from '@frontend/sports/betting-offer/feature/model';
import { GridConfig } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { TRACKING_GAMEDETAILS, TRACKING_NO_GAMEDETAILS, TrackingSource } from '@frontend/sports/tracking/feature';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { EpcotConfigService } from '../common/epcot-config.service';
import { LeftNavType } from '../event-details-common/event-details-common.models';
import { ThreeWayMarketComponent } from './three-way-market.component';
import { VerticalMarketListComponent } from './vertical-market-list.component';

@Component({
    selector: 'ms-tree-market',
    templateUrl: './tree-market.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, IconCustomComponent, ThreeWayMarketComponent, VerticalMarketListComponent],
})
export class TreeMarketComponent implements OnInit, OnChanges {
    @Input() event: EventModel;
    @Input() leftNavType: LeftNavType;

    activeMarket: EventOptionGroup;
    display3way: boolean;
    displayVerticalList: boolean;
    isMainMarketLocked: boolean;
    trackingSource: TrackingSource;
    readonly isEpcotEnabled = this.epcotConfigService.isEnabled();

    constructor(
        private msGrid: GridConfig,
        private epcotConfigService: EpcotConfigService,
    ) {}

    ngOnInit(): void {
        this.setMarketProperties();
        this.setTrackingDetails();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['event'] && !changes['event'].isFirstChange()) {
            this.setMarketProperties();
            this.setTrackingDetails();
        }
    }

    private setTrackingDetails() {
        let trackingGameDetails = TRACKING_NO_GAMEDETAILS;
        if (this.event.scoreboard.statistics && this.event.sport.id === SportConstant.Soccer && this.msGrid.showRedCardsInSoccer) {
            const stas = this.event.scoreboard.getStats<FootballStats>();
            if (stas.redcards?.totalPoints?.participant1 || stas.redcards?.totalPoints?.participant2) {
                trackingGameDetails = TRACKING_GAMEDETAILS;
            }
        }

        this.trackingSource = {
            source: this.leftNavType === LeftNavType.Live ? 'LeftNavInPlay' : 'LeftNavPrePlay',
            gameDetails: trackingGameDetails,
        };
    }

    private setMarketProperties = (): void => {
        this.activeMarket = this.event.optionGroups[0];

        if (this.activeMarket) {
            const multipleOptions = this.activeMarket.options.length > 3;
            const optionsCount = this.activeMarket.options ? this.activeMarket.options.length : 0;
            const hasMarkets = optionsCount > 0 && this.activeMarket.online;
            this.display3way = hasMarkets && optionsCount <= 3;
            this.displayVerticalList = hasMarkets && multipleOptions;
            this.isMainMarketLocked = this.activeMarket && !this.display3way && !this.displayVerticalList;
        }
    };
}
